module.exports = __webpack_public_path__ + "img/arrow_down.4d56220.svg";